import {useCallback,useEffect,useRef} from 'react';
import ringUrl from '../../../app/audio/incoming-call.wav';
import ringbackUrl from '../../../app/audio/outgoing-call.wav';

export function createRingtone(player:HTMLAudioElement,allowed:()=>boolean){
  let active=false,disposed=false,primed=false,priming:Promise<void>|null=null;
  player.preload='auto';player.volume=.6;player.loop=true;
  const stop=()=>{active=false;player.pause();player.currentTime=0;};
  const play=()=>{if(disposed||!active||!allowed())return;void player.play().then(()=>{if(disposed||!active||!allowed())player.pause();}).catch(()=>{});};
  const gesture=()=>{
    if(disposed)return;if(active){play();return;}if(primed||priming)return;
    player.volume=0;
    priming=player.play().then(()=>{primed=true;if(!active){player.pause();player.currentTime=0;}}).catch(()=>{}).finally(()=>{player.volume=.6;priming=null;});
  };
  return {start:()=>{if(disposed||active)return;active=true;play();},stop,gesture,dispose:()=>{disposed=true;stop();}};
}
function useCallTone(id:string|undefined,enabled:boolean,isPrimary:()=>boolean,url:string){
  const ref=useRef<ReturnType<typeof createRingtone>|null>(null);
  useEffect(()=>{const ring=createRingtone(new Audio(url),isPrimary);ref.current=ring;
    document.addEventListener('pointerdown',ring.gesture);document.addEventListener('keydown',ring.gesture);window.addEventListener('pagehide',ring.stop);
    return()=>{ring.dispose();ref.current=null;document.removeEventListener('pointerdown',ring.gesture);document.removeEventListener('keydown',ring.gesture);window.removeEventListener('pagehide',ring.stop);};
  },[isPrimary,url]);
  useEffect(()=>{const ring=ref.current;if(id&&enabled)ring?.start();else ring?.stop();return()=>ring?.stop();},[id,enabled,isPrimary,url]);
  return useCallback(()=>ref.current?.stop(),[]);
}
export const useIncomingRingtone=(id:string|undefined,enabled:boolean,isPrimary:()=>boolean)=>useCallTone(id,enabled,isPrimary,ringUrl);
export const useOutgoingRingtone=(id:string|undefined,enabled:boolean,isPrimary:()=>boolean)=>useCallTone(id,enabled,isPrimary,ringbackUrl);
